import { UserProfileState } from '../types/store/userProfileTypes';

export const checkIsPowerUser = (userProfile: UserProfileState): boolean => (userProfile?.administrableBusinessUnits?.length ?? 0) > 0;
